module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Qacuta/Nagano_Qacuta_HadGEM2_RCP45_Now.png";